<p *ngIf="loading" >loading ...</p>
<p *ngIf="!loading && !isError">File uploaded successfully</p>
<p  *ngIf="!loading && isError">File upload Failed</p>

<table [innerHTML]="errorList" automation-id="table-template-upload"></table>

<button (click)="backButtonClick(false)" automation-id="back-to-upload-template">Back to upload</button>